<template>
<div class="viewShed3DBox" v-if="isShow">
  <div class="item">
    <span class="dot"></span>
    <span class="name">水平张角</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.horizontalViewAngle" :show-tooltip="false" :max="90" :min="1" @input="updateShed3D"></el-slider>
    <span class="value">{{parseInt(styleOptions.horizontalViewAngle)}}</span>
  </div>
  <div class="item">
    <span class="dot" style="background: #3662EC;"></span>
    <span class="name">垂直张角</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.verticalViewAngle" :show-tooltip="false" :max="60" :min="10" @input="updateShed3D"></el-slider>
    <span class="value">{{parseInt(styleOptions.verticalViewAngle)}}</span>
  </div>
  <div class="item">
    <span class="dot" style="background: #E05F42;"></span>
    <span class="name">投射距离</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.viewDistance" :show-tooltip="false" :max="1000" :min="1" @input="updateShed3D"></el-slider>
    <span class="value">{{parseInt(styleOptions.viewDistance)}}</span>
  </div>
  <div class="item">
    <span class="dot" style="background: #A158FF;"></span>
    <span class="name">四周方向</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.viewHeading" :show-tooltip="false" :max="360" :min="-360" @input="updateShed3D"></el-slider>
    <span class="value">{{parseInt(styleOptions.viewHeading)}}</span>
  </div>
  <div class="item">
    <span class="dot" style="background: #E05F42;"></span>
    <span class="name">俯仰角度</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.viewPitch" :show-tooltip="false" :max="180" :min="-180" @input="updateShed3D"></el-slider>
    <span class="value">{{parseInt(styleOptions.viewPitch)}}</span>
  </div>
  <div class="item">
    <span class="dot" style="background: #F5AF64;"></span>
    <span class="name">透明度</span>
    <el-slider class="viewShed3DBox-slider" v-model="styleOptions.alpha" :show-tooltip="false" :max="1" :min="0" :step="0.1" @input="updateShed3D"></el-slider>
    <span class="value">{{styleOptions.alpha}}</span>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'viewShed3DBox',
  props: {},
  components: {},
  data () {
    return {
      styleOptions: {
        horizontalViewAngle: 90,
        verticalViewAngle: 60,
        viewDistance: 100,
        viewHeading: 0,
        viewPitch: 0,
        alpha: 0.5
      },
      isShow: false
    }
  },
  computed: {
    ...mapGetters(['showViewShed3DBox', 'viewShed3DData']),
    name () {
      return this.data
    }
  },
  watch: {
    viewShed3DData (newValue, oldValue) {
      if (!newValue) {
        return
      }
      Object.keys(this.styleOptions).forEach(k => {
        this.styleOptions[k] = newValue[k]
      })
    }
  },
  methods: {
    open () {
      this.isShow = true
    },
    close () {
      this.isShow = false
      this.$store.commit('SELECT_VIEWSHED3DDATA', null)
    },
    updateShed3D () {
      this.$cesiumPlus.viewShed3D.onChangeOption(this.styleOptions)
    }
  },
  filters: {}
}
</script>
<style scoped lang="scss">
.viewShed3DBox{
  width: 260px;
  height: 250px;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid #93B6F6;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.6);
  border-radius: 12px;
  position: absolute;
  z-index: 1000;
  top: 120px;
  right: 30px;
  padding: 20px;
  box-sizing: border-box;
  padding-right: 10px;
  overflow: hidden;
  .item{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    .viewShed3DBox-slider{
      width: 114px;
    }
    .dot{
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #32B18B;
      border-radius: 50%;
    }
    .name{
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      display: inline-block;
      width: 60px;
      text-align: left;
      padding-left: 4px;
    }
    .value{
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #BBBBBB;
      display: inline-block;
      width: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
<style lang="scss">
  .viewShed3DBox-slider{
    .el-slider__bar{
      height: 4px;
      background: rgba(147, 182, 246, 1);
    }
    .el-slider__button{
      border: solid 0.02rem #ffffff;
      background: rgba(147, 182, 246, 1);
      width: 12px;
      height: 12px;
    }
    .el-slider__runway{
      height: 4px;
    }
  }
</style>
